import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getRecurringTasks: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringTasks`,
        params: {
            '$count': true
        }
    },
    getRecurringTaskById: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringTasks/:taskId`
    },
    deleteRecurringTask: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/recurringTasks/:taskId`
    },
    createRecurringTask: {
        method: 'POST',
        url: `${BASE_PATH_API}/recurringTasks`
    },
    updateRecurringTask: {
        method: 'PUT',
        url: `${BASE_PATH_API}/recurringTasks/:taskId`
    },
    getStaffMembersAssigneesByRecurringTaskId: {
        method: 'GET',
        url: `${BASE_PATH_API}/v3/recurringTasks/:recurringTaskId/staffMemberAssignees`,
        isArray: true
    }
};

export function RecurringTasksApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getRecurringTasksExportUrl = function getRecurringTasksExportUrl(params) {
        return `${BASE_PATH_API}/recurringTasks/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
RecurringTasksApi.$inject = [
    '$httpParamSerializer'
];
